import { Pipe, PipeTransform } from '@angular/core';

const MS_PER_HOUR: number = 3600000;

function padZero(number): string {
	return number < 10 ? '0' + number : number;
}

@Pipe({
	name: 'vbPlayerTime',
	standalone: false
})
export class VbPlayerTimePipe implements PipeTransform {
	public transform(timeMs: number): string {
		const seconds = padZero(Math.floor((timeMs / 1000) % 60));

		const minutes = padZero(Math.floor((timeMs / (1000 * 60)) % 60));

		if (timeMs < MS_PER_HOUR) {
			return minutes + ':' + seconds;
		}
		const hours = padZero(Math.floor((timeMs / (1000 * 60 * 60)) % 24));

		return hours + ':' + minutes + ':' + seconds;
	}
}
